module.exports = __webpack_public_path__ + "assets/blueprint2.b4c6dc24.svg";